import React from "react";
import { useDispatch } from "react-redux";

import { makeStyles, Button, Container, Box, Typography } from "@material-ui/core";
import { useForm } from "../../../hooks/useForm";
import { useHistory } from "react-router";
import AfiliadoService from '../../../services/AfiliadoService'
import { startAlerta } from "../../../actions/ui/alertas";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Link } from "react-router-dom";
import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%'
    },
    submit: {
        marginTop: "1rem",
        textTransform:"none"
    },
    title: {
        fontWeight: "bold"
    }
}));
export const OlvidePasswordScreen = () => {
    const history = useHistory()
    const dispatch = useDispatch();
    const classes = useStyles()

    const initialState = {
        dni: ""
    };
    const [formValues, handleInputChange] = useForm(initialState);
    const { dni } = formValues;

    const handleChangePassword = async (e) => {
        e.preventDefault();
        try {
            dispatch(startSpinner())
            const result = await AfiliadoService.olvidarPassword(dni)
            const body = await result.json()
            if (result.ok) {
                dispatch(finishSpinner())
                dispatch(startAlerta("¡Correo electrónico enviado!", "success"))
                history.push("/afiliado/ingreso")
            } else {
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            } else {
                dispatch(startAlerta("Ha ocurrido un error en el cambio de contraseña. Intente nuevamente.", "error"))
            }
            console.log("Error en el cambio de contraseña del usuario", error)
        }
    };

    return (

        <div className={classes.root}>
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
            >
                <Container maxWidth="sm">
                    <ValidatorForm onSubmit={handleChangePassword}>
                        <Box p="1rem">
                            <Typography align="center" variant="h4" className={classes.title} color="secondary">Recupero de contraseña</Typography>
                            <Typography variant="body2" align="justify" style={{ marginTop: "1rem" }}>Ingresá tu número de documento para validar tus datos y recibir un correo electrónico con los pasos a seguir.</Typography>

                            <TextValidator
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="DNI"
                                onChange={handleInputChange}
                                name="dni"
                                validators={['required']}
                                errorMessages={['El DNI es requerido']}
                                value={dni}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                            >
                                Continuar
                            </Button>
                            <Button
                                component={Link}
                                type="button"
                                fullWidth
                                variant="outlined"
                                color="primary"
                                className={classes.submit}
                                to="/afiliado/ingreso"
                            >
                                Anterior
                            </Button>
                        </Box>
                    </ValidatorForm>
                </Container>
            </Box>
        </div>
    );
};
